<template>     
  <v-card flat>           
    <v-card-text v-if="kelengkapan.status">
      <v-alert type="success" value="true" class="ml-2 mb-1" outline>Terima Kasih, ananda telah berhasil mengupload berkas.</v-alert>      
    </v-card-text>
    <v-card-text v-if="!kelengkapan.status" class="v-table__overflow pb-0">
      <v-alert type="success" :value="true" v-if="fm.jalur_id == 3 || fm.jalur_id == 4">
        Ananda tidak perlu mengupload berkas karena sedang mengikuti jalur Internal/Undangan.
      </v-alert>
      <p class="mb-0" v-else>
        Berkas anda belum lengkap. Tombol "selanjutnya" akan aktif setelah anda mengupload berkas. Ikuti petunjuk berikut :              
      </p>
    </v-card-text>
    <v-card-text class="v-table__overflow" v-if="fm.jalur_id != 3 && fm.jalur_id != 4">
      <v-btn @click="show_upload = true" v-if="kelengkapan.status">Upload ulang berkas</v-btn><br/>
      <template v-if="show_upload">
        <ol v-if="fm.tingkat_id > 1">
          <li class="my-2">Download file berikut : 
            <v-btn round color="blue" :href="$config.url+'cdn/file/sknSD.pdf'" target="_blank" v-if="fm.tingkat_id == 2" dark small>Download Blangko Rapor</v-btn>
            <v-btn round color="blue" :href="$config.url+'cdn/file/sknSMP.pdf'" target="_blank" v-if="fm.tingkat_id == 3" dark small>Download Blangko Rapor</v-btn>
          </li>
          <li class="my-2">
            Isi blangko tersebut lalu tandatangani oleh Kepala Sekolah bersangkutan.
          </li>
          <li class="my-3">Setelah itu scan atau foto blangko yg telah ditandatangani tersebut menjadi format .pdf</li>
          <li class="my-3">Upload file .pdf pada kolom dibawah ini,  jangan lupa klik tombol upload setelah browse file :
            <div class="DashboardContainer5 my-3" style="max-height:340px"></div>
          </li>
          <li class="my-3">Setelah anda mengupload, tombol cetak kartu akan aktif. Untuk Info lebih lanjut hubungi admin.

            <span v-if="kelengkapan.status">Silahkan cetak kartu ujian anda.</span>   

          </li>
        </ol>
        <ol v-if="fm.tingkat_id == 1">        
          <li class="my-3">Scan akta kelahiran dalam format .pdf</li>
          <li class="my-3">Upload file .pdf tersebut pada kolom dibawah ini, jangan lupa klik tombol upload setelah browse file :
            <div class="DashboardContainer5 my-3" style="max-height:340px"></div>
          </li>
          <li class="my-3">Selesai. Untuk Info lebih lanjut hubungi admin.          
          </li>
        </ol>     
      </template>             
    </v-card-text>  
    <v-card-text class="printcontent pl-4 v-table__overflow" style="height: 360px;" v-if="fm.tingkat_id > 1 && (fm.jalur_id == 1 || fm.jalur_id == 2)">      
      <v-layout text-xs-center wrap class="mb-4">        
        <div style="border: 1px solid #aaa; border-radius:20px; min-width:350px; width:350px;" class="blue lighten-2 white--text">
          <v-layout row wrap>
            <div v-if="!kelengkapan.status" style="position:absolute; width:360px; height:210px; z-index:999; background: rgba(0,0,0,0.7)"></div>          
            <v-flex xs12 >
              <table style="width:100%">
                <thead>
                  <tr>
                    <th style="width:80px">
                      <img
                        :src="require('@/assets/logo.png')"
                        class="my-1"
                        style="height:50px;"
                      />
                    </th>
                    <th>
                      <h4 style="font-size:12px" class="indigo--text">PERGURUAN ISLAM <span class="green--text">AR RISALAH</span></h4>
                      <h2 style="font-size:14px">Kartu Peserta Ujian</h2>                                            
                      <h4 style="font-size:12px">TAHUN AJARAN {{$config.tahun}}</h4>
                    </th>
                  </tr>
                </thead>
              </table>
              <hr />
            </v-flex>          
            <v-flex xs12>  
              <v-layout row wrap class="my-3">
                <v-flex xs3 class="text-xs-left">
                  <div style="width:70px; height:70px; border:1px solid #eee; position: relative" class="text-xs-center mx-3 mb-2">
                    <img v-if="imgUrl" :src="imgUrl ? imgUrl : require('@/assets/img/avatar.png')" style="max-width:100%; max-height:150px;" />
                    <span  @click="cropshow=true" v-else class="caption">Pas Foto</span>                               
                  </div>
                </v-flex>
                <v-flex xs9>
                  <table style="font-size:11px">
                    <tbody>
                      <tr>
                        <td class="text-xs-left" valign="top"><strong>Nama Peserta</strong></td><td>:</td><td class="text-xs-left pl-1"><strong>{{fm.nama}}</strong></td>
                      </tr>
                      <tr>
                        <td></td>
                      </tr>
                      <tr>
                        <td class="text-xs-left" valign="top">Nama Orang Tua</td><td>:</td><td class="text-xs-left pl-1">{{fm.ayah_nama}}</td>
                      </tr>
                      <tr>
                        <td class="text-xs-left" valign="top">Jalur Masuk</td><td>:</td><td class="text-xs-left pl-1">
                          <span v-if="fm.jalur_id == 1">Reguler</span>
                          <span v-else-if="fm.jalur_id == 2">Prestasi</span>
                          <span v-else-if="fm.jalur_id == 3">Internal</span>
                          <span v-else-if="fm.jalur_id == 4">Undangan</span>
                        </td>
                      </tr>                  
                      <tr>
                        <td class="text-xs-left" valign="top">Nomor Ujian</td><td>:</td><td class="text-xs-left pl-1">{{fm.calonGedung.number}}</td>
                      </tr>                  
                    </tbody>
                  </table>                       
                </v-flex>   
              </v-layout>             
              <!--<hr/>   -->
            </v-flex>   
            <!--<v-flex xs12 class="pa-3">              
              <h3 class="caption">Padang, {{$moment().format('DD MMM YYYY')}}</h3>
              <h3 class="caption">Ketua Panitia PPDB</h3>
              <img src="@/assets/img/ttdsyatri.png" style="max-height:110px; margin-top:-30px; margin-bottom:-30px" />
              <h3 class="caption">SYATRI, S.E., M.Pd.</h3>
              <h3 class="caption">NIKY. 2008.01.1984.11.21-007 </h3>
            </v-flex>-->         
          </v-layout>        
        </div>              
      </v-layout> 

      <v-btn round v-if="fm.tingkat_id > 1" :disabled="!kelengkapan.status" color="success" :loading="loadingActive" @click="printerPlugin()"><v-icon> print</v-icon> &nbsp; Cetak</v-btn>                           
    </v-card-text> 
    <v-card-text></v-card-text>
    <v-card-actions v-if="fm.jalur_id != 4">
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="(!kelengkapan.status && fm.jalur_id != 3 && fm.jalur_id != 4)" :loading="nextLoading" class="px-3" @click="nextStep()" >Selanjutnya</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Model from '@/models/dashboard';
import User  from '@/util/models/User';
import 'uppy/dist/uppy.min.css';
const  model = new Model();
import Interface   from '@/util/interface';
const  api = Interface.biz4;

export default {
  name:'step5',  
  props:['stepke', 'fmi'],  
  data:()=>({  
    cropshow: false,
    stepkeLocal : null,
    conti : false,
    user : User.attributes(),
    imgLoading : false,
    loadingActive:false,
    imgUrl : null,
    show_upload:true,
    fm : {
      user : {
          username : null,
          phone : null,
          password : null,
          status : 10,
      },
      user_id : null,
      tingkat_id : null,
      jurusan_id : null,
      nama : null,
      gender : null,
      lahir_tempat : null,
      lahir_tanggal : null,
      lahir_tanggalV : null,
      alamat : null,
      kelurahan_id : null,
      kecamatan_id : null,
      kota_id : null,
      provinsi_id : null,
      prestasi_osn : null,
      prestasi_mtq : null,
      prestasi_hafidz : null,
      prestasi_other : null,
      sekolah_nama : null,
      sekolah_provinsi_id : null,
      sekolah_kota_id : null,
      telepon : null,
      whatsapp : null,
      email : null,
      ayah_nama : null,
      ayah_pekerjaan : null, 
      ayah_jabatan : null,
      ayah_penghasilan : null,
      ibu_nama : null,
      ibu_pekerjaan : null, 
      ibu_jabatan : null,
      ibu_penghasilan : null,
      calonPrestasis : [],
      calonGedung : {
        gedung : {},
        ruang : {}
      },      
    },
    kelengkapan : {
      status : false,
      items  : [],
      headers : [
        {text:'No', value:'id'},
        {text:'Berkas', value:'name'},
        {text:'Status', value:'status'},
      ]
    },
    first:true, nextLoading:false,
  }),
  mounted(){
    this.init(); this.getavatar(); 
  },
  watch:{
    'kelengkapan.status'(nStatus){
      if(nStatus){
        this.show_upload = false
      } else {
        this.show_upload = true
      }
    },
    'show_upload'(nStat){
      if(nStat)setTimeout(()=>{this.setUploads()}, 1000); 
    },  
    stepke(newStep){this.init()},      
  },
  methods:{
    init(){
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        Object.assign(this.fm, data);        
        setTimeout(()=>{
          if(this.first){
            this.setUploads()
            this.first = false
          }
        }, 2000);        
      });  
      
      model.kelengkapans().then(res => {        
        this.kelengkapan.status = res.status;
        this.kelengkapan.items  = res.data;                
      });
    },
    
    nextStep(){
      if(this.kelengkapan.status || this.fm.jalur_id == 3 || this.fm.jalur_id == 4){
        this.nextLoading = true      
        model.setCetak().then(()=>{
          this.nextLoading = false
          if(  (this.fm.tingkat_id == 3 &&  this.fm.jalur_id == 3) 
            || (this.fm.tingkat_id == 2 && (this.fm.jalur_id == 3 || this.fm.jalur_id == 4))
            || (this.fm.tingkat_id == 1 && (this.fm.jalur_id == 3 || this.fm.jalur_id == 1))
          ){
            this.$emit('update:stepke', 7);            
          } else {
            this.$emit('update:stepke', 6);            
          }               
        })        
      }        
    },



    printerPlugin(){
      this.conti = true;
      model.setCetak();
      print();
    }, 
    
    getJadwalUjian(tingkat){
      switch(tingkat){case 2:return 'Sabtu, 4 Januari 2020, 07:00 WIB'; break; case 3:return 'Ahad, 23 Februari 2020, 07:00 WIB'; break; default:return 'none'; break;}
    },
        
    cropSuccess(imgDataUrl, field){
      
      //this.imgDataUrl = imgDataUrl;

      var block = imgDataUrl.split(";");
      var contentType = block[0].split(":")[1];// In this case "image/gif"
      var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      var blob = this.b64toBlob(realData, contentType);

      var FormData = require('form-data');
      let formData = new FormData();

      formData.append('image', blob, 'userprofile');
      formData.append('reff_id', this.user.id);
      formData.append('reff_type', 1);        

      this.imgLoading = true;
      model.setavatar(formData).then(res=>{
        this.getavatar();            
      });
    }, 
    
    getavatar(){
      this.imgLoading  = true;
      model.getavatar({reff_id:this.user.id}).then(res=>{
        if(res.data){
          this.imgUrl      = res.data;          
        }
        this.imgLoading  = false;
      });
    },
    
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },

    setUploads(){
      try{
        const Uppy = require('@uppy/core')
        const Dashboard = require('@uppy/dashboard')
        const XHRUpload = require('@uppy/xhr-upload')
        //const GoogleDrive = require('@uppy/google-drive')
        //const Dropbox = require('@uppy/dropbox')
        //const Instagram = require('@uppy/instagram')
        //const Webcam = require('@uppy/webcam')
        //const Tus = require('@uppy/tus')
        
        const rest = api.setter('ppdb/dashboard/upload-berkas');
        const uppy = Uppy({
          debug: false,
          autoProceed: false,
          restrictions: {
            maxFileSize: 100000000,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: ['application/pdf']
            //allowedFileTypes: ['image/*', 'video/*']
          }
        })
        .use(Dashboard, {
          trigger: '.UppyModalOpenerBtn',
          inline: true,
          target: '.DashboardContainer5',
          replaceTargetContent: true,
          showProgressDetails: true,
          note: 'PDF only, 1–20 files, up to 100 MB',
          height: 350,
          width:'100%',
          metaFields: [
            { id: 'name', name: 'Name', placeholder: 'file name' },
            { id: 'caption', name: 'Caption', placeholder: 'describe what the file is about' }
          ],
          browserBackButtonClose: true
        })
        //.use(GoogleDrive, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
        //.use(Dropbox, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
        //.use(Instagram, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
        //.use(Webcam, { target: Dashboard })
        //.use(Tus, { endpoint: 'https://master.tus.io/files/' })
        .use(XHRUpload, {
          endpoint: rest.endpoint,
          headers: rest.headers,
          formData: true,
          fieldName: 'file',  
        })
        uppy.on('complete', (result) => {
          if(result.successful && result.successful.length > 0){
            this.loadingActive = true;
            setTimeout(()=>{this.kelengkapan.status = true; this.loadingActive = false;}, 2000)          
          }        
        });      
      }catch(e){}
    },
  }
};
</script>
<style>
.printcontent * {visibility: visible; color:#000;}  
.printcontent {position : relative; top:0px; left:0px; z-index: 0}  
@media print
{
    body * {visibility:hidden;}
    .printcontent * {visibility : visible;}
    .printcontent {position : fixed; top:0px; left:0px;}
}
.uppy-Dashboard-poweredBy {
    display: none!important;
    text-align: center!important;
    font-size: 11px!important;
    color: #939393!important;
    text-decoration: none!important;
    margin-top: 8px!important;
}
</style> 

